// import axios from 'axios';

// export const getRequestConfig = (url, params) => {
//     const config = {
//         url,
//         params,
//     }
//     const requestUrl = axios.getUri([config]);
// }

export const js2param = (obj) => {
    const params = new URLSearchParams();
    for(const key in obj) {
        if(Array.isArray(obj[key])){
            for(const i in obj[key]) {
                params.append(key, obj[key][i]);
            }
        } else {
            params.append(key, obj[key]);
        }
    }

    return params;
}

export const getAirportCode = airport => {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(airport);

    if(Array.isArray(matches) && matches.length >= 2) {
        return matches[1];
    }

    return '';
}

export const getUrlParameter = (name) => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const getLang = () => {
    let lang = getUrlParameter('lang');

    return lang === '' ? 'en' : lang.toLowerCase();
}

export const mapLangCode = () => {
    let lang = getLang();
    if (lang === 'cn') {
        lang = 'zh';
    } else if (lang === 'tw') {
        lang = 'zh-tw';
    }

    return lang;
}

export const getLocale =() => {
    const lang = getLang();
    switch (lang) {
        case 'vi':
            return 'vi-VI';
        case 'en':
            return 'en-US';
        case 'fr':
            return 'fr-FR';
        case 'de':
            return 'de-DE';
        case 'ru':
            return 'ru-RU';
        case 'ko':
            return 'ko-KR';
        case 'ja':
            return 'ja-JP';
        case 'cn':
            return 'zh-CN';
        case 'tw':
            return 'zh-TW';
        case 'th':
            return 'th-th';
        default:
            return 'en-US';
    }
}

export const getLocaleAndLang = () => {
    const lang = getLang();
    switch (lang) {
        case 'vi':
            return {locale:'vn', lang:'vi'};
        case 'en':
            return {locale:'vn', lang:'en'};
        case 'fr':
            return {locale:'fr', lang:'fr'};;
        case 'de':
            return {locale:'de', lang:'de'};
        case 'ru':
            return {locale:'ru', lang:'ru'};
        case 'ko':
            return {locale:'kr', lang:'ko'};
        case 'ja':
            return {locale:'jp', lang:'ja'};
        case 'cn':
            return {locale:'cn', lang:'zh'};
        case 'tw':
            return {locale:'tw', lang:'zh-tw'};
        case 'th':
            return {local:'th', lang:'th'};
        default:
            return {locale:'vn', lang:'en'};
    }
}